import './styles.scss';
import { useIntl } from 'react-intl';
import format from 'date-fns/format';
import { useLazyQuery } from '@apollo/client';
import { comparison, modelVersions } from 'cache';
import { Query, QuerySearchSimilarEurotaxCodesArgs } from 'generated/graphql';
import { EUROTAX_CODES } from 'apollo-client/queries/getSimilarEurotaxCodes';
import { PopupProps } from 'components/Popup';
import { ModalContext } from 'providers/modal-provider';
import { useContext } from 'react';

export const CompareCard: (
  p: Partial<
    Record<'vehicleRegistrationPlate' | 'brandName' | 'modelName' | 'vehicleRegistrationDateISO8601', string>
  > & {
    modelVersion?: ReadonlyArray<string>;
  }
) => JSX.Element | null = ({
  vehicleRegistrationPlate,
  brandName,
  modelName,
  modelVersion,
  vehicleRegistrationDateISO8601,
}) => {
  const { setModal } = useContext(ModalContext);
  const { formatMessage } = useIntl();
  const [onGetSimilarEurotaxCodes] = useLazyQuery<Query, QuerySearchSimilarEurotaxCodesArgs>(EUROTAX_CODES, {
    onError: () => {
      setModal<PopupProps>({
        type: 'Popup',
        props: {
          message: formatMessage({ id: 'error' }),
          details: formatMessage({ id: 'generic.error' }),
          status: 'ERROR',
        },
      });
    },
    onCompleted: (res) => {
      const availableModelVersions = res.searchSimilarEurotaxCodes?.map(({ label, eurotaxCode }) => ({
        value: eurotaxCode,
        label,
      }));
      modelVersions(availableModelVersions);
    },
  });
  const hasSingleModelVersion = Array.isArray(modelVersion) && modelVersion.length === 1;
  return modelName ? (
    <div className="filterList__primaryFilters">
      <div className="active" />
      <ul className="filters">
        {vehicleRegistrationPlate ? (
          <li>
            <p className="filter__title">{formatMessage({ id: 'license' })}</p>
            <p className="filter__value">{vehicleRegistrationPlate}</p>
          </li>
        ) : null}
        <li>
          <p className="filter__title">{formatMessage({ id: 'brand-name' })}</p>
          <p className="filter__value">{brandName}</p>
        </li>
        {modelName ? (
          <li>
            <p className="filter__title">{formatMessage({ id: 'model-name' })}</p>
            <p className="filter__value">{modelName}</p>
          </li>
        ) : null}
        {hasSingleModelVersion ? (
          <li>
            <p className="filter__title">{formatMessage({ id: 'model-version' })}</p>
            <p className="filter__value">{modelVersion}</p>
          </li>
        ) : null}
        <li>
          <p className="filter__title">{formatMessage({ id: 'vehicle-registration-date' })}</p>
          <p className="filter__value">
            {vehicleRegistrationDateISO8601
              ? format(new Date(vehicleRegistrationDateISO8601 as string), 'MM/yyyy')
              : '-'}
          </p>
        </li>
      </ul>

      {hasSingleModelVersion ? (
        <button
          onClick={(): void => {
            onGetSimilarEurotaxCodes({
              variables: {
                inputEurotaxCode: comparison().eurotaxCode,
              },
            });
          }}
        >
          {formatMessage({ id: 'show-more-model-version' })}
        </button>
      ) : null}
    </div>
  ) : null;
};
